export type ObjectTreeItemType = {
  id: number
  name: string
  type: number
  icon: string
  alias: string
  parent: number
  parents: number[]
  child_count: { [key: number]: number }
  status: number
  children: ObjectTreeItemType[]
}

export const ObjectTreeLink = {
  INVENTORY: { link: 'map', sort: 0 },
  MAP: { link: 'map', sort: 1 },
  REPORTS: { link: 'reports/invent_act', sort: 2 },
  MONITORING: { link: 'monitoring', sort: 3 },
  EVENTS: { link: 'events', sort: 4 },
  TASKS: { link: 'tasks', sort: 5 },
  ADMIN: { link: 'admin', sort: 6 },
}
